<template>
  <form-layout
    class="item-form"
    entity-name="item"
    :loading="isLoading"
    @save="saveItem"
  >
    <template #title>
      <h1 class="uppercase font-bold text-xl">{{ titleText }}</h1>
    </template>
    <template #body>
      <bdg-text-field
        ref="name"
        name="Item name"
        :required="true"
        v-model="itemData.name"
      />

      <bdg-dropdown
        name="Associated vendor"
        :options="vendors"
        empty-state-text="No vendors available."
        v-model="itemData.contact_id"
        searchable
      />
    </template>
  </form-layout>
</template>

<script>
import BdgTextField from "../../forms/fields/BdgTextField";
import FormLayout from "../layouts/FormLayout";
import BdgDropdown from "../../forms/fields/BdgDropdown";
import { validateRequiredRefs } from "../../helpers";

export default {
  name: "ItemForm",
  components: { BdgDropdown, FormLayout, BdgTextField },
  props: {
    id: { type: Number },
    name: { type: String, default: "" },
    contact_id: { type: Number }
  },
  data() {
    return {
      itemData: {
        id: this.id,
        name: this.name,
        contact_id: this.contact_id
      },
      requiredRefs: ["name"]
    };
  },
  computed: {
    titleText() {
      return this.id ? "Edit Item" : "Create New Item";
    },
    vendors() {
      const vendors = this.$store.state.Contacts.vendors;
      if (vendors) {
        return vendors.map(v => {
          return {
            label: v.companyAndContactNamesString,
            value: v.id
          };
        });
      }
      return vendors;
    },
    isStoringItem() {
      return this.$store.state.Items.isStoringItem;
    },
    isUpdatingItem() {
      return this.$store.state.Items.isUpdatingItem;
    },
    isLoading() {
      return this.id ? this.isUpdatingItem : this.isStoringItem;
    }
  },
  created() {
    this.$store.dispatch("getVendors");
  },
  methods: {
    validate() {
      return validateRequiredRefs(this, true);
    },
    saveItem() {
      if (!this.validate()) {
        return;
      }

      if (this.id) {
        this.$store.dispatch("updateItem", this.itemData);
      } else {
        this.$store.dispatch("storeItem", this.itemData);
      }
    }
  }
};
</script>
